//import "./css/ListaHorariosDisponibles.css";
import { useContext, useState, useEffect, useRef } from "react";

import NombreDia from "./DiaHorario";

import {
  Carousel,
  Card,
  Row,
  Col,
  Container,
  Button
} from "react-bootstrap";
import { ChevronLeft, ChevronRight } from "react-bootstrap-icons";

import {
  Titulo,
  Cargando,
  excepcionVacia,
  llamarApi,
  cadenaFechaADate,
  MensajeExcepcion,
  logger
} from "./Comun";

import Contexto from "./Contexto";
import { isObject } from "lodash";

const ListaHorariosDisponibles = (props) => {
  const parametros = useContext(Contexto);

  const [isLoading, setIsLoading] = useState(true);

  const [grupoDias, setGrupoDias] = useState(0);
  const [resListaHorariosDisponibles, setResListaHorariosDisponibles] =
    useState(null);

  const fetchEjecutado = useRef(false);
  const [submitEnEjecucion, setSubmitEnEjecucion] = useState(false);

  const handleClickHorario = async (horario) => {
    if (submitEnEjecucion) return;
    setSubmitEnEjecucion(true);

    if (horario) {
      const urlAPI =
        parametros.urlBaseApis + "sh";

      llamarApi({
        url: urlAPI,
        jwt: props.jwt,        
        method: "POST",
        payload: {
            idSede: props.idSede,
            idCanalCaptacion: parametros.idCanalCaptacion,
            idTipoSesion: props.idTipoSesion,
            horarioSeleccionado: horario,
            idEmpleado: props.idEmpleado,
             ...(props.idSolicitudSesion != null && {idSolicitudSesion: props.idSolicitudSesion}),
        },
        onSuccess: (data) => {
          props.setJwt(data.jwt);          
          
          if (
            props.idSolicitudSesion === null ||
            props.idSolicitudSesion !== data.idSolicitudSesion
          ) {
            props.setIdSolicitudSesion(data.idSolicitudSesion);
          }

          props.setHorarioSeleccionado(horario);
          props.irAPAso("FDC");
          props.setExcepcion(excepcionVacia);
        },
        onError: (err) => {
          props.setExcepcion(err);
        },
        onFinally: () => setSubmitEnEjecucion(false),
      });
    }
  };

  const handleClickOtroTipoSesion = async (e) => {
    props.setIdTipoSesion(null);
    props.setHorarioSeleccionado(null);
    props.irAPAso("LTS");
  };

  const handleClickOtraSede = () => {
    props.setIdSede(null);
    props.setIdEmpleado(null);
    props.setIdTipoSesion(null);
    props.irAPAso("LS");
  };

  const handleClickOtroEmpleado = () => {
    props.setIdEmpleado(null);
    props.setIdTipoSesion(null);
    props.irAPAso("LE");
  };

  const handleChangeGrupoDias = (grupoDiasSeleccionados) => {
    setGrupoDias(grupoDiasSeleccionados);
  };

  const chunk = (arr, size) =>
    Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
      arr.slice(i * size, i * size + size)
    );

  // Ensure each chunk has exactly N items (pad with nulls if needed)
  const normalizeChunk = (chunk, size) => {
    const diff = size - chunk.length;
    return diff > 0 ? [...chunk, ...Array(diff).fill(null)] : chunk;
  };

  useEffect(() => {
    if (fetchEjecutado.current) return;
    fetchEjecutado.current = true;

    logger(
      new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        "." +
        new Date().getSeconds() +
        "- Render del lista horarios"
    );

    let urlAPI = parametros.urlBaseApis + "lh";

    llamarApi({
      url: urlAPI,
      jwt: props.jwt,       
      method: "GET",
      payload: {
        idSede: props.idSede,
        ...(props.idEmpleado != null && { idEmpleado: props.idEmpleado }),
        idTipoSesion: props.idTipoSesion,
        ...(props.idSolicitudSesion != null && {
          idSolicitudSesion: props.idSolicitudSesion,
        }),
      },

      onSuccess: (data) => {
        props.setJwt(data.jwt);        
        setResListaHorariosDisponibles(data.datosHorarios);
        props.setExcepcion(excepcionVacia);
      },
      onError: (err) => props.setExcepcion(err),
      onFinally: () => setIsLoading(false),
    });
  }, [
    props.idSede,
    props.idEmpleado,
    props.idTipoSesion,
    props.idSolicitudSesion,
  ]);

  if (isLoading) return <Cargando mensaje="Cargando horarios ..."></Cargando>;

  const screenWidth = window.innerWidth;
  let chunkSize = 6; // default large screens
  if (screenWidth < 768) chunkSize = 3;       // small screens
  else if (screenWidth < 1200) chunkSize = 4; // medium screens

  // Chunk the horarios array
  const arrayHorariosDisponibles =
    resListaHorariosDisponibles &&
    Array.isArray(resListaHorariosDisponibles.arrayHorariosDisponibles)
      ? chunk(resListaHorariosDisponibles.arrayHorariosDisponibles, chunkSize)
      : []; // Le pongo un array vacío porque luego si mira el lenght para ver si saco chevrones, y fallaría

  // Si ha ocurrido un error, el listado potencialmente viene a null
 /* const arrayHorariosDisponibles =
    resListaHorariosDisponibles !== null &&
    resListaHorariosDisponibles.arrayHorariosDisponibles !== null &&
    Array.isArray(resListaHorariosDisponibles.arrayHorariosDisponibles)
      ? chunk(resListaHorariosDisponibles.arrayHorariosDisponibles, 6)
      : []; */// Le pongo un array vacío porque luego si mira el lenght para ver si saco chevrones, y fallaría

  return (
    <>
      <Titulo textoTitulo="Selecciona el horario en el que quieres tu cita"></Titulo>
      <Container className="flex-grow-1 d-flex flex-column py-4 position-relative text-center  px-2">
      
        {resListaHorariosDisponibles && isObject(resListaHorariosDisponibles) && Object.hasOwn(resListaHorariosDisponibles, "algunHorarioDisponible") && resListaHorariosDisponibles.algunHorarioDisponible !== 1 ? (
           <Row className="flex-fill">
          <MensajeExcepcion
                        mensaje={parametros.textoErrorSinHorariosDisponibles} permitirCerrar={false}></MensajeExcepcion></Row>
        ) : (
  <Row className="flex-fill">
          <Col>
            <Carousel
              activeIndex={grupoDias}
              onSelect={handleChangeGrupoDias}
              indicators={false}
              interval={null}
              wrap={false}
              prevIcon={
                grupoDias > 0 ? (
                  <ChevronLeft
                    size={28}
                    className="carousel-control-prev text-muted "
                  />
                ) : (
                  <span />
                )
              }
              nextIcon={
                grupoDias < arrayHorariosDisponibles.length - 1 ? (
                  <ChevronRight
                    size={28}
                    className="carousel-control-next text-muted"
                  />
                ) : (
                  <span />
                )
              }
            >
              {arrayHorariosDisponibles.map(
                (grupoHorariosDisponibles, indiceGrupoHorarios) => (
                  <Carousel.Item key={`slide-${indiceGrupoHorarios}`}>
                    <Row className="justify-content-center">
                     {grupoHorariosDisponibles.map(
                          (horariosDisponiblesFecha, i) => {
                          let nombreDiaFormateado = null;
                          let diaYMesFormateado = null;
                          if (horariosDisponiblesFecha) {
                            const fechaDate = cadenaFechaADate(
                              horariosDisponiblesFecha.fecha
                            );
                            const nombreDia = fechaDate.toLocaleDateString(
                              "es-ES",
                              { weekday: "long" }
                            );
                            diaYMesFormateado = fechaDate.toLocaleDateString(
                              "es-ES",
                              {
                                day: "2-digit",
                                month: "short",
                              }
                            );

                            nombreDiaFormateado =
                              nombreDia.charAt(0).toUpperCase() +
                              nombreDia.slice(1);
                          }

                          // Capitalize first letter for cleaner look (optional)

                          return (
                            <Col
                              xs={4}
                              sm={4}
                              md={2}
                              lg={2}
                              key={`day-${indiceGrupoHorarios}-${i}`}
                              className="mb-3 px-1 px-md-2 col-auto"
                            >
                              {horariosDisponiblesFecha ? (
                                <Card className="h-100 shadow-sm">
                                  <Card.Body>
                                    <Card.Title className="text-center">
                                      <NombreDia dia={nombreDiaFormateado} />
                                      <p className="pt-0 pt-md-1 pb-1 pb-md-2 m-0 fechaDiaHorario">
                                        {diaYMesFormateado}
                                      </p>
                                    </Card.Title>
                                    {horariosDisponiblesFecha.hayHorasDisponibles !==
                                    1 ? (
                                      <div className="p-1 mb-1 rounded text-center bg-light text-muted" style={{ cursor: "not-allowed" }}>-</div>
                                      /*
                                      <Card.Text className="alert alert-light">
                                        <span className="d-block d-xl-none">-</span> 
                                        <span className="d-none d-xl-block">Sin horarios disponibles</span>
                                      </Card.Text>*/
                                    ) : (
                                      horariosDisponiblesFecha.arrayHorariosFecha.map(
                                        (horario) => {
                                          const isAvailable =
                                            horario.disponible !== "-";
                                          return isAvailable ? (
                                            <div
                                              key={
                                                horariosDisponiblesFecha.fecha +
                                                "_" +
                                                horario.hora
                                              }
                                              className={`p-1 mb-1 rounded text-center ${
                                                isAvailable
                                                  ? "horario-disponible fw-semibold cursor-pointer"
                                                  : "bg-light text-muted text-decoration-line-through"
                                              }`}
                                              style={{
                                                cursor: isAvailable
                                                  ? "pointer"
                                                  : "not-allowed",
                                              }}
                                              onClick={() =>
                                                isAvailable &&
                                                handleClickHorario(
                                                  horariosDisponiblesFecha.fecha +
                                                    "_" +
                                                    horario.hora
                                                )
                                              }
                                            >
                                              {horario.hora}
                                            </div>
                                          ) : (
                                            ""
                                          );
                                        }
                                      )
                                    )}
                                  </Card.Body>
                                </Card>
                              ) : (
                                // Empty placeholder to preserve grid structure
                                <div className="invisible">placeholder</div>
                              )}
                            </Col>
                          );
                        }
                      )}
                    </Row>
                  </Carousel.Item>
                )
              )}
            </Carousel>
          </Col>{" "}
        </Row>          
        )}

    <Row className="justify-content-center text-center">
          <Col>
            <Button onClick={handleClickOtroTipoSesion} className="px-3 mx-2">
              Seleccionar otro tipo de sesi&oacute;n
            </Button>
            {parametros.empleadoSeleccionable === 1 ? (
              <Button onClick={handleClickOtroEmpleado} className="px-3 mx-2">
                Seleccionar otro especialista
              </Button>
            ) : (
              ""
            )}
            {parametros.multiSede === 1 ? (
              <Button onClick={handleClickOtraSede} className="px-3 mx-2">
                Seleccionar otra clínica
              </Button>
            ) : (
              ""
            )}
          </Col>
        </Row>

        <Cargando
          mensaje="Verificando la disponibilidad el horario solicitado ..."
          visible={submitEnEjecucion}
        ></Cargando>
      </Container>
    </>
  );
};
export default ListaHorariosDisponibles;
